export { default } from './StarRating'
